/* istanbul ignore file */
import React from 'react';
import { EditTimelineRecordButton, DeleteTimelineRecordButton } from 'domain/shared/timeline/button';
import useResumeService, {
  DISPLAY_RESUME_DELETE_BUTTON_PERMISSION,
  DISPLAY_RESUME_UPDATE_BUTTON_PERMISSION,
  READ_CANDIDATE_RESUMES,
} from 'domain/recruiting/candidate/Timeline/resume/resumeService';
import { useShowContext } from 'framework/show';
import { candidateTimelineRecords } from 'domain/recruiting/candidate/shared/timeline';
import BasePersonTimelineRecordLayout from 'domain/shared/timeline/person/PersonTimelineRecord/BasePersonTimelineRecordLayout';
import { CANDIDATE_TIMELINE_ICONS, CANDIDATE_TIMELINE_MESSAGE_CONTEXT } from 'domain/shared/candidate';

type ResumeTimelineRecordLayoutProps = {
  onEdit: () => void;
  actionName: string;
};

const ResumeTimelineRecordLayout = ({ onEdit, ...props }: ResumeTimelineRecordLayoutProps) => {
  const { deleteById } = useResumeService();
  const { data } = useShowContext();

  const buttons = [
    <EditTimelineRecordButton permissionToCheck={DISPLAY_RESUME_UPDATE_BUTTON_PERMISSION} key="edit" onEdit={onEdit} />,
    <DeleteTimelineRecordButton
      permissionToCheck={DISPLAY_RESUME_DELETE_BUTTON_PERMISSION}
      deleteMethod={deleteById}
      key="add"
      id={data.getValueBySource('id')}
      timelineId={data.getValueBySource('timelineId')}
      entityName="resume"
    />,
  ];

  return (
    <BasePersonTimelineRecordLayout
      permissionToCheck={READ_CANDIDATE_RESUMES}
      timelineType={candidateTimelineRecords.RESUME_ADDED}
      artifactsSource="artifacts"
      buttons={buttons}
      timelineIcons={CANDIDATE_TIMELINE_ICONS}
      messageContext={CANDIDATE_TIMELINE_MESSAGE_CONTEXT}
      {...props}
    />
  );
};

export default ResumeTimelineRecordLayout;
